"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RaceForRewardsCreator = void 0;
const link_1 = __importDefault(require("next/link"));
const RaceForRewardsCreator = ({ creator }) => {
    return (<link_1.default href={creator.url} passHref>
			<a>
				<div className="my-8 flex cursor-pointer">
					<Image creator={creator}/>
					<div className="m-2">
						<DisplayName creator={creator}/>
						<CreatorDetails creator={creator}/>
					</div>
				</div>
			</a>
		</link_1.default>);
};
exports.RaceForRewardsCreator = RaceForRewardsCreator;
const Image = ({ creator }) => (<img src={creator.avatar} alt={creator.displayName} className="w-[50px] h-[50px] rounded-full shadow-green-glow m-2"/>);
const DisplayName = ({ creator }) => (<div>
		<span className="text-xl font-medium">{creator.displayName}</span>
	</div>);
const CreatorDetails = ({ creator }) => (<div className="flex items-center justify-center">
		<span className="uppercase text-sm text-tertiary mx-1">Followers:</span>
		<span className="text-l font-medium mx-1">{creator.followerCount.toLocaleString()}</span>
		<span className="uppercase text-sm text-tertiary mx-1">Total dares:</span>
		<span className="text-l font-medium mx-1">{creator.deliveryCount}</span>
	</div>);
